import CompaniesService from "@/services/companies";
import { IDBPDatabase } from "idb/build/esm/entry";
import DataService from "@/services/data-service/data-service";
import IEpmdHeader from "@/models/epmd-header";
import ICompany from "@/models/company";
import VmsDbSchema from "@/models/VmsDbSchema";

export default class DataCompanyService {
  private company = new CompaniesService();

  constructor(private $db: Promise<IDBPDatabase<VmsDbSchema>>, private $dataService: DataService) {}

  public actions = {
    Get: this.Get.bind(this)
  };

  public initialize() {
    return this.actions.Get();
  }

  private async Get() {
    if (!this.$dataService.getters.isOfflineSupport()) return this.company.get();
    return (await this.getCompanies()) ?? (await this.setCompanies());
  }

  private async setCompanies() {
    const data = await this.company.get();
    const encryptData = DataService.encryptData(data);
    await (await this.$db).put("Companies", encryptData, 0);
    return data;
  }

  private async getCompanies() {
    const encryptedData = await (await this.$db).get("Companies", 0);
    if (!encryptedData) return null;
    return DataService.decryptData<ICompany[]>(encryptedData);
  }
}
